import { CalendarDays, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import SectionHeading from '../components/SectionHeading'
import { localBusinessSchema } from '../config/schema'
import { imageSize } from '../data/images'

export default function News() {
  return (
    <>
      <SEO page="news" structuredData={localBusinessSchema} />
      <PageHero index="07" eyebrow="News" title="Stay informed. Stay connected." description="Updates and events from Diamond Suites Ocala." image="news-banner-img.webp" />
      <section className="section">
        <div className="container">
          <SectionHeading index="01" eyebrow="Latest updates" title="What is happening at Diamond Suites" />
          <div className="news-grid">
            <article className="news-card news-card--featured">
              <div className="news-card__media">
                <img src={`${import.meta.env.BASE_URL}images/community-main.jpg`} alt="Diamond Suites Ocala exterior" {...imageSize('community-main.jpg')} loading="lazy" />
              </div>
              <div className="news-card__body">
                <p className="eyebrow">Community event</p>
                <h2>Welcome Open House</h2>
                <p>
                  Guests were invited to tour the modern suites, meet beauty and wellness professionals, enjoy refreshments, and discover Ocala’s newest collective beauty destination.
                </p>
                <ul className="event-details">
                  <li><CalendarDays /> June 5, 2025, 4:00 PM to 7:00 PM</li>
                  <li><MapPin /> 7494 SW 60th Ave, Suite A, Ocala, FL 34476</li>
                </ul>
              </div>
            </article>
            <article className="news-card">
              <div className="news-card__body">
                <p className="eyebrow">Professional opportunities</p>
                <h2>Join the Diamond Suites community</h2>
                <p>
                  We are always interested in meeting skilled, client-focused professionals who are ready to grow their independent business in a polished private suite environment.
                </p>
                <Link className="text-link" to="/contact/">Ask about the waitlist</Link>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  )
}
